import type { HipSpineUserPreferenceData } from '@/stores/hipSpinePreferences/types';
import {
    MAX_ANTEVERSION,
    MAX_INCLINATION,
    MIN_ANTEVERSION,
    MIN_INCLINATION,
} from '@/domain/anatomy/pelvis/anteversionInclination';

export type FieldErrorKind = 'out-of-range' | 'inverted';

function isInRange(value: number | null, min: number, max: number): boolean {
    return value === null || (value >= min && value <= max);
}

function isInvertedBounds(lower: number | null, upper: number | null): boolean {
    return lower !== null && upper !== null && lower >= upper;
}

export const validators: Record<
    string,
    (p: HipSpineUserPreferenceData) => FieldErrorKind | null
> = {
    maxCupInclinationBound: ({ maxCupInclinationBound }) =>
        isInRange(maxCupInclinationBound, MIN_INCLINATION, MAX_INCLINATION)
            ? null
            : 'out-of-range',
    minCupInclinationBound: ({ minCupInclinationBound, maxCupInclinationBound }) => {
        if (!isInRange(minCupInclinationBound, MIN_INCLINATION, MAX_INCLINATION)) {
            return 'out-of-range';
        }
        if (isInvertedBounds(minCupInclinationBound, maxCupInclinationBound)) {
            return 'inverted';
        }
        return null;
    },
    maxCupAnteversionBound: ({ maxCupAnteversionBound }) =>
        isInRange(maxCupAnteversionBound, MIN_ANTEVERSION, MAX_ANTEVERSION)
            ? null
            : 'out-of-range',
    minCupAnteversionBound: ({ minCupAnteversionBound, maxCupAnteversionBound }) => {
        if (!isInRange(minCupAnteversionBound, MIN_ANTEVERSION, MAX_ANTEVERSION)) {
            return 'out-of-range';
        }
        if (isInvertedBounds(minCupAnteversionBound, maxCupAnteversionBound)) {
            return 'inverted';
        }
        return null;
    },
};
